'use client';

import { authClient } from '@/lib/auth/auth-client';
import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { Suspense } from 'react';

const OneSignalContent = () => {
  const pathname = usePathname();
  const { data: session } = authClient.useSession();

  const isDevelopment = process.env.NODE_ENV === 'development';
  const isProtectedArea = pathname?.startsWith('/admin');

  if (isDevelopment || isProtectedArea || !session?.user) return null;

  return (
    <>
      <Script
        src="https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js"
        strategy="afterInteractive"
      />
      <Script id="onesignal-init" strategy="afterInteractive">
        {`
          window.OneSignalDeferred = window.OneSignalDeferred || [];
          OneSignalDeferred.push(async function(OneSignal) {
            await OneSignal.init({
              appId: "676969b2-f5d8-4355-9f05-cf1b7583ff81",
              safari_web_id: "web.onesignal.auto.560021c2-877c-448b-9811-f001e7b5ec58",
              notifyButton: {
                enable: false,
              },
            });
            
            // Register identity so the server actions can send targeted push notifications
            const userId = "${session?.user?.id || ''}";
            if (userId) {
              await OneSignal.login(userId);
            }
          });
        `}
      </Script>
    </>
  );
};

export function OneSignalScript() {
  return (
    <Suspense fallback={null}>
      <OneSignalContent />
    </Suspense>
  );
}
